const I = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIgMWM2LjA3NSAwIDExIDQuOTI1IDExIDExcy00LjkyNSAxMS0xMSAxMVMxIDE4LjA3NSAxIDEyIDUuOTI1IDEgMTIgMXptMCAyYTkgOSAwIDEgMCAwIDE4IDkgOSAwIDAgMCAwLTE4em0wIDEyLjk5OGExIDEgMCAxIDEgMCAyIDEgMSAwIDAgMSAwLTJ6bTEuMDA0LTEwdjhoLTIuMDAxdi04aDJ6IiAgZmlsbC1ydWxlPSJldmVub2RkIi8+PC9zdmc+";
export {
  I as default
};
//# sourceMappingURL=alert_circle-375a6036.mjs.map
